<template>
  <div class="registerComponent">
    <p>Логин</p>
    <input type="text" id="login" placeholder="Введите имя пользователя" v-model="login" />
    <p>Пароль</p>
    <div class="passwordInput">
      <input :type="showPassword ? 'password' : 'text'" id="password" placeholder="Введите пароль" v-model="password" />
      <Transition name="fade"><img src="../assets/icons/openEye.svg" width="26px" @click="togglePasswordVisibility" v-if="showPassword" /></Transition>
      <Transition name="fade"><img src="../assets/icons/closeEye.svg" width="28px" @click="togglePasswordVisibility" v-if="!showPassword" /></Transition>
    </div>
    <p>Подтвердите пароль</p>
    <div class="passwordInput">
      <input :type="showConfirmPassword ? 'password' : 'text'" id="confirmPassword" placeholder="Повторите пароль" v-model="confirmPassword" />
      <Transition name="fade"><img src="../assets/icons/openEye.svg" width="26px" @click="toggleConfirmPasswordVisibility" v-if="showConfirmPassword" /></Transition>
      <Transition name="fade"><img src="../assets/icons/closeEye.svg" width="28px" @click="toggleConfirmPasswordVisibility" v-if="!showConfirmPassword" /></Transition>
    </div>
    <button class="authButton" @click="signUpButton">Зарегистрироваться</button>
    <a href="#" style="text-align: center; color: #333333b2; text-decoration: underline">Политика конфиденциальности и правила сервиса</a>
    <Transition name="fade">
      <ErrorBlock v-show="isError" />
    </Transition>
  </div>
</template>

<script>
import axios from "axios";
import { useToast } from "vue-toastification";
import ErrorBlock from "./ErrorBlock.vue";

export default {
  name: "RegisterComponent",
  data() {
    return {
      login: "",
      password: "",
      confirmPassword: "",
      showPassword: true,
      showConfirmPassword: true,
      isError: false,
    };
  },
  components: {
    ErrorBlock,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    showError(element) {
      let el = document.querySelector(element);
      let posY = el.offsetTop;
      el = document.querySelector(".errorBlock");
      el.style.top = posY + "px";
      setTimeout(() => {
        this.isError = false;
      }, 2000);
    },
    signUpButton() {
      if (!this.login.trim()) {
        this.isError = true;
        this.showError("#login");
        return;
      }

      if (!this.password) {
        this.isError = true;
        this.showError("#password");
        return;
      }

      if (!this.confirmPassword) {
        this.isError = true;
        this.showError("#confirmPassword");
        return;
      }

      if (this.password !== this.confirmPassword) {
        this.isError = true;
        this.showError("#confirmPassword");
        this.toast.error("Пароли не совпадают");
        return;
      }

      axios
        .post(`https://${process.env.VUE_APP_SERVERHOST}/api/auth/register`, {
          login: this.login.trim(),
          password: this.password,
          city: "Москва",
        })
        .then((res) => {
          this.$store.commit("setUserData", res.data.result);
          this.toast.success("Вы успешно зарегистрировали аккаунт!", { timeout: 2000 });
          window.location.reload();
        })
        .catch((err) => {
          this.toast.error(err.response?.data?.message || "Не удалось зарегистрироваться");
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.registerComponent {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
}
.authButton {
  background-color: #ff8989;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: 1px solid #ff8989;
  padding: 13px;
  color: white;
  font-weight: 600;
  border-radius: 10px;
  cursor: pointer;
}
input {
  outline: none;
  background-color: #ffffff;
  border-radius: 10px;
  border: 1px solid #d8dadc;
  padding: 15px;
}
p {
  color: #333333;
  font-size: 14px;
}
.passwordInput {
  position: relative;
}
.passwordInput input {
  width: 100%;
}
.passwordInput img {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
@media (max-width: 968px) {
  .registerComponent input {
    padding: 10px;
  }
}
</style>
